import { Header } from "../../components/Header";
import { HeroHome } from "./HeroHome";
import { AboutComponent } from "./AboutComponent";
import './Home.css';
import  HomeBanner  from '../Home/HomeBanner';
import OpportunityTimeline from './OpportunityTimeline';
import { ServicesComponent } from "./ServicesComponent";
import { ProcessComponent } from "./ProcessComponent";
import { StatsComponent } from "./StatsComponent";
import { Footer } from "../../components/Footer";
import Slider from "./Slider";
import Quote from './Quote';
import Rotate from "./Rotate";
import PEBStructure from "./PEBStructure.jsx";
import Customer from "./Customer.jsx";
import  Info  from "./Info.jsx";


export const Home = () => {
    return (
        <>
       
    <HeroHome />
    <Customer/>
    <AboutComponent />
   <Slider/>
   
   <Rotate/>
   <PEBStructure/>
   <Info/> 
    <Quote/>
   
    <Footer/>
    {/* <section className="flex items-center justify-center">
 

    <div class="our-services">Our Services</div>
    <div class="fast-and-professional-logistic-services">
      <span>
        <span class="fast-and-professional-logistic-services-span">
          Fast and professional
        </span>
        <span class="fast-and-professional-logistic-services-span2"></span>
        <span class="fast-and-professional-logistic-services-span3">
          Logistic services
        </span>
      </span>
    </div>
    <div class="frame-325">
      <img class="rectangle-112" src={image1120} />
      <div
        class="comprehensive-reliable-cost-effective-ocean-freight-solutions-for-seamless-global-trade-shipping"
      >
        Comprehensive, Reliable &amp; Cost-Effective Ocean Freight Solutions for
        Seamless Global Trade &amp; Shipping.
      </div>
      <div class="ocean-freight">Ocean Freight</div>
      <div class="frame-323">
        <img class="image-14" src={image140} />
      </div>
      <div class="component-6">
        <div class="learn-more">Learn More</div>
        <div class="arrow-arrow-right">
            <div class="circle"></div>
          <img class="arrow-right" src={arrowRight0} />
        </div>
      </div>
    </div>
    <div class="frame-326">
      <img class="rectangle-1122" src={image1121} />
      <div
        class="comprehensive-reliable-cost-effective-ocean-freight-solutions-for-seamless-global-trade-shipping"
      >
        Comprehensive, Reliable &amp; Cost-Effective Ocean Freight Solutions for
        Seamless Global Trade &amp; Shipping.
      </div>
      <div class="air-freight">Air Freight</div>
      <div class="frame-323">
        <img
          class="freepicdownloader-com-airplane-hong-kong-international-airport-large"
          src={freepicdownloaderComAirplaneHongKongInternationalAirportLarge}
        />
      </div>
      <div class="component-6">
        <div class="learn-more">Learn More</div>
        <div class="arrow-arrow-right">
          <div class="circle"></div>
          <img class="arrow-right2" src={arrowRight1} />
        </div>
      </div>
    </div>
    <div class="frame-327">
      <img class="rectangle-1123" src={image1122} />
      <div
        class="comprehensive-reliable-cost-effective-ocean-freight-solutions-for-seamless-global-trade-shipping"
      >
        Comprehensive, Reliable &amp; Cost-Effective Ocean Freight Solutions for
        Seamless Global Trade &amp; Shipping.
      </div>
      <div class="road-freight">Road Freight</div>
      <div class="frame-323">
        <img class="image-18" src={image180} />
      </div>
      <div class="component-6">
        <div class="learn-more">Learn More</div>
        <div class="arrow-arrow-right">
          <div class="circle"></div>
          <img class="arrow-right3" src={arrowRight2} />
        </div>
      </div>
    </div>
    <div class="component-3">
      <div class="view-all">View all</div>
      <div class="arrow-arrow-right2">
        <div class="circle2"></div>
        <img class="arrow-right4" src={arrowRight3} />
      </div>
    </div>
    </section> */}
    </>
    )
 }  

 export default Home;